import { Table } from 'antd';
import React from 'react';
import { DynamicObjectType } from 'types/commons';
import VariantNameItem from './VariantNameItem';
import { sumBy } from 'lodash';
import { TableProductSelectedStyles } from './OrderSelected';

interface ITableProductSelectedTypes {
  variantsApplied?: DynamicObjectType[];
  openVariantSelectionModal?: (value) => void;
}

const TableProductSelected = ({
  variantsApplied,
}: ITableProductSelectedTypes) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 500,
      render: (d, rc) => (
        <div className="pl-2.5">
          <VariantNameItem item={rc} />
        </div>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantityEdited',
      key: 'quantityEdited',
    },
  ];

  return (
    <TableProductSelectedStyles>
      <Table
        columns={columns}
        dataSource={variantsApplied}
        rowKey="id"
        pagination={false}
        summary={(pageData) => {
          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                {sumBy(pageData, 'quantityEdited')}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </TableProductSelectedStyles>
  );
};

export default TableProductSelected;
